import { useEffect, useMemo, useRef, useState } from "react";

import styles from "./index.module.scss";

import { Image } from "react-bootstrap";
import { Description } from "../CustomComponent";


export default function Carousel({ TOTAL_ITEMS = [] }) {
    const containerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const velocityRef = useRef(0);
    const lastXRef = useRef(0);
    const animationFrameRef = useRef(null);
    const CONTAINER_WIDTH = useMemo(() => 300, []); // pixel
    const CONTAINER_GAP = useMemo(() => 25, []); // pixel
    const [totalBars, setTotalBars] = useState(0);
    const [currentBar, setCurrentBar] = useState(1);

    // const TOTAL_ITEMS = Array(8).fill(9)


    useEffect(() => {
        const handleResize = () => {
            if (!containerRef.current) return

            const perPageItem = getPerPageItems();
            const barsCount = Math.ceil(TOTAL_ITEMS?.length / perPageItem)

            setTotalBars(barsCount)
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);



    useEffect(() => {
        if (!containerRef.current) return


        const perPageItem = getPerPageItems();
        const barsCount = Math.ceil(TOTAL_ITEMS.length / perPageItem)

        setTotalBars(barsCount)

    }, [containerRef.current, lastXRef.current])



    function getContainerTotalScroll() {
        const containerWidth = containerRef.current.clientWidth;
        const containerScroll = containerRef.current.scrollWidth;
        return containerScroll - containerWidth;

    }

    function getPerPageItems() {
        const containerWidth = containerRef.current.clientWidth;
        const itemCount = Math.floor(containerWidth / CONTAINER_WIDTH)
        return itemCount

    }

    // Handle mouse down / touch start
    const startDrag = (e) => {
        setIsDragging(true);
        velocityRef.current = 0;
        lastXRef.current = getClientX(e);
        if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
    };

    // Handle mouse move / touch move
    const onDrag = (e) => {
        if (!isDragging || !containerRef.current) return;

        const x = getClientX(e);
        const delta = x - lastXRef.current;
        lastXRef.current = x;

        containerRef.current.scrollLeft -= delta;
        velocityRef.current = delta; // Capture velocity
    };

    // Handle mouse up / touch end
    const endDrag = () => {
        setIsDragging(false);
        applyInertia();
    };

    // Apply inertia effect
    const applyInertia = () => {
        if (!containerRef.current) return;

        let velocity = velocityRef.current;
        const friction = 0.97; // Adjust for more/less resistance

        const step = () => {
            if (Math.abs(velocity) < 0.5) return;
            if (!containerRef.current) return;

            containerRef.current.scrollLeft -= velocity;
            velocity *= friction;
            animationFrameRef.current = requestAnimationFrame(step);
        };

        step();
    };

    // Get X coordinate for both touch and mouse events
    const getClientX = (e) => {
        return "touches" in e ? e.touches[0].clientX : e.clientX;
    };


    const smoothScroll = (to, duration = 500) => {
        const start = containerRef.current.scrollLeft;
        const maxScroll = containerRef.current.scrollWidth - containerRef.current.clientWidth;
        const target = Math.max(0, Math.min(to, maxScroll)); // Clamp value to prevent bouncing
        const change = target - start;
        const startTime = performance.now();

        function animateScroll(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            containerRef.current.scrollLeft = start + change * easeInOutQuad(progress);

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        }

        requestAnimationFrame(animateScroll);
    };
    const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;



    const handleBarClick = (barNo) => {

        if (barNo === 1) {
            smoothScroll(0)
            setCurrentBar(barNo)
            return
        }
        if (barNo === totalBars) {
            velocityRef.current = 200
            const totalScroll = getContainerTotalScroll();
            smoothScroll(totalScroll)
            setCurrentBar(barNo)
            return
        }


        const perPageItem = getPerPageItems();
        smoothScroll((barNo - 1) * (((perPageItem - 1) * CONTAINER_GAP) + (perPageItem * CONTAINER_WIDTH)))
        setCurrentBar(barNo)
        return
    }

    return (
        <div
            className={styles.Carousel}
        >
            <div
                className={styles.CarouselContainer}
                ref={containerRef}
                onMouseDown={startDrag}
                onMouseMove={onDrag}
                onMouseUp={endDrag}
                onMouseLeave={endDrag}
                onTouchStart={startDrag}
                onTouchMove={onDrag}
                onTouchEnd={endDrag}
                style={{ gap: CONTAINER_GAP }}
            >
                {TOTAL_ITEMS?.map((item, index) => {
                    return <div
                        className={styles.contentContainer}
                        style={{ minWidth: CONTAINER_WIDTH, maxWidth: CONTAINER_WIDTH }}
                        key={item.id}
                    >
                        <Image
                            src={item?.cover_image_url}
                            // src="/assets/temp/upcoming-quiz-cover.png"
                            alt="Porfolio Image 1"
                            className={styles.image}
                            draggable={false}
                        />
                        <div className={styles.content}>
                            <Description
                                text={item?.title}
                                size="5"
                            />
                            <Description
                                text={`${item?.quiz_questions?.length} Question`}
                                size="7"
                            />
                        </div>
                    </div>
                }
                )}
            </div>
            {totalBars <= 1 ? "" : <div className={styles.Bars}>
                {Array(totalBars).fill(0)?.map((_, index) => {
                    return <span
                        className={`${styles.bar} ${currentBar == index + 1 ? styles.active : ""}`}
                        key={index}
                        onClick={() => handleBarClick(index + 1)}
                    >
                    </span>
                })}
            </div>
            }
        </div>

    )
}
